import { Controller } from '@hotwired/stimulus'

// Guías de la portada de cuentas (ENH-RNK-7023): en móvil y tableta cada fase se pliega y
// se despliega con su cabecera, y empiezan plegadas. En escritorio no se pliegan: los botones
// están ocultos y las listas siempre a la vista. Sin JavaScript se ven todas desplegadas.
export default class extends Controller {
  static targets = ['boton', 'lista']

  connect () {
    this.compacto = window.matchMedia('(max-width: 1023px)')
    this.alCambiarAncho = this.alCambiarAncho.bind(this)
    this.compacto.addEventListener('change', this.alCambiarAncho)
    this.element.classList.add('con-plegado')
    this.alCambiarAncho()
  }

  disconnect () {
    this.compacto.removeEventListener('change', this.alCambiarAncho)
  }

  alCambiarAncho () {
    this.botonTargets.forEach((_boton, indice) => this.mostrar(indice, !this.compacto.matches))
  }

  plegar (evento) {
    const indice = this.botonTargets.indexOf(evento.currentTarget)
    this.mostrar(indice, evento.currentTarget.getAttribute('aria-expanded') !== 'true')
  }

  mostrar (indice, visible) {
    this.botonTargets[indice].setAttribute('aria-expanded', visible)
    this.listaTargets[indice].hidden = !visible
  }
}
